export const spamKeywords = [
  'visit',
  'claim',
  'official website',
  'swap',
  'airdrop',
  'voucher',
  'rewards',
  'reward',
  'invite link',
  'earn',
  'giveaway',
  'free',
  'bonus',
  'profit',
  'staking',
  'stake',
  'distribution',
  'promotion',
  'launchpad',
  'launch',
  'drop',
  'referral',
  'get',
  'reward link',
  'access',
  'extra',
  'exclusive',
  'redeem',
  'gift',
  'discount',
  'token drop',
  'faucet',
  'raffle',
  'metawin',
  'dotcom',
]

export const spamPatterns = [
  /http[s]?:\/\//,
  /www\./,
  /\.com/,
  /\.net/,
  /\.org/,
  /\.info/,
  /\.xyz/,
  /\.site/,
  /\.app/,
  /\.online/,
  /\.link/,
  /\.top/,
  /\.vip/,
  /\.cc/,
  /\.biz/,
  /\.store/,
  /\.pro/,
  /\.ltd/,
  /\.space/,
  /\bdotcom\b/i, // matches words like "dotcom" in token names
  /@/, // matches names with "@" (common in spammy names)
]
